export const translations = {
  vi: {
    // Dashboard
    dashboard: {
      title: 'Tổng quan tài khoản',
      account: 'Tài khoản',
      overview: 'Tổng quan',
      layout: 'Bố cục',
      premium: 'Premium',
      templates: 'Mẫu',
      helpCenter: 'Trung tâm trợ giúp',
      myPage: 'Trang của tôi',
      shareProfile: 'Chia sẻ hồ sơ',
      logout: 'Đăng xuất',
      loading: 'Đang tải...',
      // Account Overview
      accountOverview: 'Tổng quan tài khoản',
      username: 'Tên người dùng',
      displayName: 'Tên hiển thị',
      uid: 'UID',
      email: 'Email',
      // Layout Selection
      layoutTitle: 'Chọn bố cục hồ sơ',
      layoutCard: 'Bố cục thẻ (Mặc định)',
      layoutModern: 'Bố cục hiện đại',
      layoutDescription: 'Chọn cách hiển thị hồ sơ của bạn với mọi người.',
      currentLayout: 'Bố cục hiện tại',
      selectLayout: 'Chọn',
      // Statistics
      statistics: 'Thống kê',
      views: 'Views',
      likes: 'Lượt thích',
      score: 'Điểm số',
      achievements: 'Thành tích',
      // Quick Actions
      editProfile: 'Chỉnh sửa hồ sơ',
      createProfile: 'Tạo hồ sơ',
      viewPublicProfile: 'Xem hồ sơ công khai',
      // Email Verification
      emailNotVerified: 'Email chưa được xác thực',
      checkEmail: 'Vui lòng kiểm tra email {email} và click link xác thực.',
      checkSpam: 'Kiểm tra cả thư mục Spam/Junk',
      resendEmail: 'Gửi lại email xác thực',
      sendingEmail: 'Đang gửi email...',
      emailSent: 'Email xác thực đã được gửi đến {email}. Vui lòng kiểm tra hộp thư (kể cả Spam folder).',
      emailError: 'Lỗi: {message} (Code: {code})',
      waiting: 'Đợi 1-2 giờ rồi thử lại',
      rateLimitNote: 'Firebase có giới hạn 100 emails/ngày. Vui lòng đợi 1-2 giờ hoặc kiểm tra email đã gửi trước đó.',
      // Language
      language: 'Ngôn ngữ',
      vietnamese: 'Tiếng Việt',
      english: 'English'
    },
    // Profile Editor
    profileEditor: {
      customize: 'Tùy chỉnh',
      links: 'Liên kết',
      mediaUploads: 'Tải lên Media',
      generalCustomization: 'Tùy chỉnh chung',
      save: 'Lưu',
      cancel: 'Hủy',
      // Presence Card (Modern Layout)
      presenceCard: 'Thẻ hoạt động (Layout Hiện đại)',
      presenceType: 'Loại hoạt động',
      presenceTitle: 'Tiêu đề hoạt động',
      presenceSubtitle: 'Chi tiết hoạt động',
      activityPlaying: 'Đang chơi',
      activityListening: 'Đang nghe',
      activityWatching: 'Đang xem',
      activityStreaming: 'Đang stream',
      activityCompeting: 'Đang thi đấu',
      // Language
      language: 'Ngôn ngữ',
      vietnamese: 'Tiếng Việt',
      english: 'English'
    },
    // Premium
    premium: {
      title: 'Premium',
      activate: 'Kích hoạt',
      status: 'Trạng thái',
      membership: 'Premium Membership',
      subtitle: 'Mở khóa các tính năng độc quyền và nâng cấp hồ sơ của bạn',
      active: 'Premium Active',
      activeMessage: 'Bạn đang có Premium! Còn lại',
      days: 'ngày',
      expires: 'Hết hạn:',
      freeAccount: 'Free Account',
      freeAccountMessage: 'Bạn chưa có Premium. Kích hoạt ngay để mở khóa tất cả tính năng!',
      paymentTab: 'Thanh toán MoMo',
      codeTab: 'Activation Code',
      selectPackage: 'Chọn gói Premium',
      mostPopular: 'Phổ biến nhất',
      forever: 'Vĩnh viễn',
      processing: 'Đang xử lý...',
      payWithMoMo: 'Thanh toán MoMo',
      activateByCode: 'Kích hoạt Premium bằng Code',
      enterCode: 'Nhập activation code',
      activated: 'Đã kích hoạt',
      activatePremium: 'Kích hoạt Premium',
      backToDashboard: '← Quay lại Dashboard',
      createProfileFirst: 'Vui lòng tạo profile trước khi thanh toán Premium!',
      createProfileFirstActivate: 'Vui lòng tạo profile trước khi kích hoạt Premium!',
      enterCodeError: 'Vui lòng nhập activation code',
      invalidCode: 'Activation code không hợp lệ!',
      activateSuccess: 'Kích hoạt Premium thành công! Bạn có Premium trong {days} ngày.',
      activateError: 'Lỗi khi kích hoạt Premium: {error}',
      paymentInitError: 'Không thể khởi tạo thanh toán. Vui lòng thử lại sau.',
      paymentError: 'Lỗi khi khởi tạo thanh toán: {error}'
    },
    // Home
    home: {
      features: 'Tính năng',
      pricing: 'Giá',
      dashboard: 'Dashboard',
      login: 'Đăng nhập',
      register: 'Đăng ký miễn phí',
      logout: 'Đăng xuất',
      heroTitle: 'Tạo hồ sơ trở nên<br />Đặc biệt<br />Phi thường',
      heroTitleOld: 'Mọi thứ bạn muốn, ngay tại đây.',
      heroSubtitle: 'Bạn có thể nhanh chóng tạo các hồ sơ ấn tượng và tùy chỉnh bộ sưu tập của riêng mình trực tiếp trên KonOne.',
      heroSubtitleOld: 'Tạo hồ sơ cá nhân đẹp mắt với link riêng, tùy chỉnh giao diện và chia sẻ với mọi người.',
      goToDashboard: 'Vào Dashboard',
      registerForFree: 'Đăng ký miễn phí',
      viewPricing: 'Xem giá',
      statsTitle: 'Hơn {count} người đang sử dụng — Bạn còn chờ gì nữa?',
      statsDescription: 'Tạo trang link-in-bio phong phú, tùy chỉnh và hiện đại, cùng với lưu trữ file nhanh chóng và an toàn, tất cả với KonOne.',
      views: 'Lượt xem hồ sơ',
      users: 'Người dùng',
      files: 'File đã tải lên',
      subscribers: 'Người đăng ký',
      ctaText: 'Tạo hồ sơ và đăng ký tài khoản trong vài phút!',
      createNow: 'Tạo ngay',
      pricingTitle: 'Khám phá các gói độc quyền và tham gia cùng {name}',
      free: 'Free',
      freePrice: '0₫',
      freePeriod: '/ Trọn đời',
      freeDescription: 'Dành cho người mới bắt đầu, liên kết tất cả mạng xã hội của bạn tại một nơi.',
      premium: 'Premium',
      premiumPrice: '39,000₫',
      premiumPeriod: '/ tháng',
      premiumSubtitle: 'Bạn sẽ trờ nên đặc biệt nhẩt.',
      premiumDescription: 'Gói hoàn hảo để khám phá sự sáng tạo và mở khóa nhiều tính năng hơn.',
      popular: 'Phổ biến nhất',
      getStarted: 'Bắt đầu',
      learnMore: 'Tìm hiểu thêm',
      // Language
      language: 'Ngôn ngữ',
      vietnamese: 'Tiếng Việt',
      english: 'English',
      // Community
      community: 'Cộng đồng'
    },
    // Community
    community: {
      title: 'Cộng đồng',
      subtitle: 'Khám phá và kết nối với các thành viên trong cộng đồng KonOne',
      searchPlaceholder: 'Tìm kiếm theo tên, username, hoặc mô tả...',
      loading: 'Đang tải profiles...',
      error: 'Lỗi khi tải danh sách profiles: {error}',
      profileCount: '{count} profile',
      profilesCount: '{count} profiles',
      noProfiles: 'Không tìm thấy profile nào.',
      clearSearch: 'Xóa bộ lọc tìm kiếm',
      dashboard: 'Dashboard',
      editProfile: 'Edit Profile',
      login: 'Login',
      signUp: 'Sign Up',
      noName: 'No name'
    }
  },
  en: {
    // Dashboard
    dashboard: {
      title: 'Account Overview',
      account: 'Account',
      overview: 'Overview',
      layout: 'Layout',
      premium: 'Premium',
      templates: 'Templates',
      helpCenter: 'Help Center',
      myPage: 'My Page',
      shareProfile: 'Share Profile',
      logout: 'Logout',
      loading: 'Loading...',
      // Account Overview
      accountOverview: 'Account Overview',
      username: 'Username',
      displayName: 'Display Name',
      uid: 'UID',
      email: 'Email',
      // Layout Selection
      layoutTitle: 'Select Profile Layout',
      layoutCard: 'Card Layout (Default)',
      layoutModern: 'Modern Layout',
      layoutDescription: 'Choose how your profile is displayed to everyone.',
      currentLayout: 'Current Layout',
      selectLayout: 'Select',
      // Statistics
      statistics: 'Statistics',
      views: 'Views',
      likes: 'Likes',
      score: 'Score',
      achievements: 'Achievements',
      // Quick Actions
      editProfile: 'Edit Profile',
      createProfile: 'Create Profile',
      viewPublicProfile: 'View Public Profile',
      // Email Verification
      emailNotVerified: 'Email not verified',
      checkEmail: 'Please check your email {email} and click the verification link.',
      checkSpam: 'Also check Spam/Junk(Trash) folder',
      resendEmail: 'Resend verification email',
      sendingEmail: 'Sending email...',
      emailSent: 'Verification email sent to {email}. Please check your inbox (including Spam folder).',
      emailError: 'Error: {message} (Code: {code})',
      waiting: ' Wait 1-2 hours then try again',
      rateLimitNote: ' Firebase has a limit of 100 emails/day. Please wait 1-2 hours or check previously sent emails.',
      // Language
      language: 'Language',
      vietnamese: 'Tiếng Việt',
      english: 'English'
    },
    // Profile Editor
    profileEditor: {
      customize: 'Customize',
      links: 'Links',
      mediaUploads: 'Media Uploads',
      generalCustomization: 'General Customization',
      save: 'Save',
      cancel: 'Cancel',
      // Presence Card (Modern Layout)
      presenceCard: 'Activity Card (Modern Layout)',
      presenceType: 'Activity Type',
      presenceTitle: 'Activity Title',
      presenceSubtitle: 'Activity Details',
      activityPlaying: 'Playing',
      activityListening: 'Listening to',
      activityWatching: 'Watching',
      activityStreaming: 'Streaming',
      activityCompeting: 'Competing in',
      // Language
      language: 'Language',
      vietnamese: 'Tiếng Việt',
      english: 'English'
    },
    // Premium
    premium: {
      title: 'Premium',
      activate: 'Activate',
      status: 'Status',
      membership: 'Premium Membership',
      subtitle: 'Unlock exclusive features and enhance your profile',
      active: 'Premium Active',
      activeMessage: 'You have Premium! Remaining',
      days: 'days',
      expires: 'Expires:',
      freeAccount: 'Free Account',
      freeAccountMessage: 'You don\'t have Premium yet. Activate now to unlock all features!',
      paymentTab: 'MoMo Payment',
      codeTab: 'Activation Code',
      selectPackage: 'Select Premium Package',
      mostPopular: 'Most Popular',
      forever: 'Forever',
      processing: 'Processing...',
      payWithMoMo: 'Pay',
      activateByCode: 'Activate Premium with Code',
      enterCode: 'Enter activation code',
      activated: 'Activated',
      activatePremium: 'Activate Premium',
      backToDashboard: '← Back to Dashboard',
      createProfileFirst: 'Please create a profile before paying for Premium!',
      createProfileFirstActivate: 'Please create a profile before activating Premium!',
      enterCodeError: 'Please enter activation code',
      invalidCode: 'Invalid activation code!',
      activateSuccess: 'Premium activated successfully! You have Premium for {days} days.',
      activateError: 'Error activating Premium: {error}',
      paymentInitError: 'Cannot initiate payment. Please try again later.',
      paymentError: 'Error initiating payment: {error}'
    },
    // Home
    home: {
      features: 'Features',
      pricing: 'Pricing',
      dashboard: 'Dashboard',
      login: 'Login',
      register: 'Register for free',
      logout: 'Logout',
      heroTitle: 'Collect Extra<br />Ordinary<br />Profiles',
      heroTitleOld: 'Everything you want, right here.',
      heroSubtitle: 'You can quickly create stunning profiles and customize your own collections directly on KonOne.',
      heroSubtitleOld: 'Create a beautiful personal profile with a unique link, customize the interface and share with everyone.',
      goToDashboard: 'Go to Dashboard',
      registerForFree: 'Register for free',
      viewPricing: 'View Pricing',
      statsTitle: 'Over {count} users — What are you waiting for?',
      statsDescription: 'Create feature-rich, customizable and modern link-in-bio pages with fast and secure file storage, all with KonOne.',
      views: 'Profile Views',
      users: 'Users',
      files: 'Files Uploaded',
      subscribers: 'Subscribers',
      ctaText: 'Create a profile and register an account in minutes!',
      createNow: 'Create Now',
      pricingTitle: 'KonOne Plan',
      free: 'Free',
      freePrice: '$0',
      freePeriod: '/ Lifetime',
      freeDescription: 'For beginners, link all your social networks in one place.',
      premium: 'Premium',
      premiumPrice: '$2.9',
      premiumPeriod: '/ month',
      premiumSubtitle: 'You will become the most special.',
      premiumDescription: 'The perfect plan to explore creativity and unlock more features.',
      popular: 'Most Popular',
      getStarted: 'Get Started',
      learnMore: 'Learn More',
      // Language
      language: 'Language',
      vietnamese: 'Tiếng Việt',
      english: 'English',
      // Community
      community: 'Community'
    },
    // Community
    community: {
      title: 'Community',
      subtitle: 'Discover and connect with members of the KonOne community',
      searchPlaceholder: 'Search by name, username, or description...',
      loading: 'Loading profiles...',
      error: 'Error loading profiles: {error}',
      profileCount: '{count} profile',
      profilesCount: '{count} profiles',
      noProfiles: 'No profiles found.',
      clearSearch: 'Clear search filter',
      dashboard: 'Dashboard',
      editProfile: 'Edit Profile',
      login: 'Login',
      signUp: 'Sign Up',
      noName: 'No name'
    }
  }
};

// Helper function to get translation with placeholder replacement
export function t(language, key, params = {}) {
  const keys = key.split('.');
  let value = translations[language];

  for (const k of keys) {
    value = value?.[k];
  }

  if (!value) {
    console.warn(`Translation missing for key: ${key}`);
    return key;
  }

  // Replace placeholders like {email}, {message}, etc.
  return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
    return params[paramKey] || match;
  });
}

